import React from 'react';
import { get, isEmpty, find } from 'lodash';
import { LineItem } from './line-item';
import { TooltipData } from '../elements-tooltip/tooltip';
import currencySym from 'currency-symbol-map';
import {
  RevisedCalculator,
  TableLabel,
  BorderBottomLineItem
} from './line-item-helpers';
import { injectIntl } from 'react-intl';

const OvertimeSummary = ({ contractsQuote = {}, hoursValue, currencyType, intl }) => {
  const children = get(contractsQuote, 'children', [])
  const overtimeContract = find(children, { type: 'ADJUSTMENT' }) || {};

  const updateDifference = get(contractsQuote, 'master.calculations.update_difference', {})
  const { guest_fee = 0, host_fee = 0, additional_payment = 0, payout = 0 } = updateDifference;

  const spaceRentalTax = get(updateDifference, 'guest_us_space_rental_tax')
  const addOnsTax = get(updateDifference, 'guest_us_add_on_tax')

  const subtotal = get(contractsQuote, 'master.calculations.overtime.amount', 0);

  const overtimeDetails = get(overtimeContract, 'meta.info', {});
  const rateDisplayValue = (overtimeDetails.rate * overtimeDetails.multiplier) || 0;

  return (
    <RevisedCalculator>
      <TableLabel
        firstCaption={{
          optionalClass: 'table-label'
        }}
        secondCaption={{
          optionalClass: 'right-data table-label'
        }}
      />
      <LineItem
        label={{
          content: !subtotal ? intl.formatMessage({ id: 'inbox_bookingID_overtime.overtime_summary.overtime_charge', defaultMessage: 'Overtime charge' })
            : intl.formatMessage({ id: 'inbox_bookingID_overtime.overtime_summary.overtime_time', defaultMessage: '{time} overtime' }, { time: `${currencySym(currencyType)}${rateDisplayValue.toFixed(2)} x ${hoursValue} hr${1 < hoursValue ? 's' : ''}` })
        }}
        value={{
          ...(subtotal ? { amount: subtotal } : { customValue: '-' })
        }}
        currencyType={currencyType}
      />
      <LineItem
        label={{
          content: intl.formatMessage({ id: 'inbox_bookingID_overtime.overtime_summary.fee', defaultMessage: 'Service fee' }),
          optionalTooltip: TooltipData.SERVICE_FEE
        }}
        value={{
          ...(host_fee ? { amount: `${host_fee}` } : { customValue: '-' })
        }}
        currencyType={currencyType}
      />
      <BorderBottomLineItem />
      <LineItem
        label={{
          content: intl.formatMessage({ id: 'inbox_bookingID_overtime.overtime_summary.total', defaultMessage: 'Total overtime payout' }),
          optionalClass: 'overtime-total'
        }}
        value={{
          ...(payout ? { amount: -payout } : { customValue: '-' }),
          optionalClass: 'remove-vertical-align overtime-total'
        }}
        currencyType={currencyType}
        customClass="margin"
      />
      <LineItem
        label={{
          content: intl.formatMessage({ id: 'inbox_bookingID_overtime.overtime_summary.guest_pay', defaultMessage: 'Guest will pay' }),
          optionalClass: 'h6',
          optionalTooltip: !isEmpty(contractsQuote) ? TooltipData.CURRENT_TOTAL({
            content: (
              <div>
                <TooltipCalculator
                  overtimeRate={rateDisplayValue}
                  overtimeDuration={hoursValue}
                  overtimeSubtotal={subtotal}
                  overtimeGuestFee={guest_fee}
                  overtimeGuestCharge={additional_payment}
                  spaceRentalTax={spaceRentalTax}
                  addOnsTax={addOnsTax}
                  currencyType={currencyType}
                  intl={intl}
                />
              </div>
            )
          }) : null
        }}
        value={{
          ...(additional_payment ? { amount: additional_payment } : { customValue: '-' }),
          optionalClass: 'h6'
        }}
        currencyType={currencyType}
      />
    </RevisedCalculator>
  );
};


const TooltipCalculator = ({ overtimeRate, overtimeDuration, overtimeSubtotal, overtimeGuestFee, overtimeGuestCharge, currencyType, intl, addOnsTax, spaceRentalTax }) => {
  return (
    <RevisedCalculator>
      <LineItem
        label={{
          content: !overtimeGuestCharge
            ? intl.formatMessage({ id: 'inbox_bookingID_overtime.tooltip_calculator.overtime_charge', defaultMessage: 'Overtime charge' })
            : intl.formatMessage({ id: 'inbox_bookingID_overtime.tooltip_calculator.overtime_time', defaultMessage: '{time} overtime' }, { time: `${currencySym(currencyType)}${overtimeRate.toFixed(2)} x ${overtimeDuration} hr${1 < overtimeDuration ? 's' : ''}` })
        }}
        value={{
          ...(overtimeSubtotal ? { amount: overtimeSubtotal } : { customValue: '-' })
        }}
        currencyType={currencyType}
      />
      <LineItem
        label={{
          content: intl.formatMessage({ id: 'inbox_bookingID_overtime.tooltip_calculator.processing', defaultMessage: 'Processing' })
        }}
        value={{
          ...(overtimeGuestFee ? { amount: overtimeGuestFee } : { customValue: '-' })
        }}
        currencyType={currencyType}
      />
      {spaceRentalTax > 0 && (
        <LineItem
          label={{
            content: intl.formatMessage({
              id: 'overtime_summary.space_rental_sales_tax',
              defaultMessage: 'Space rental sales tax'
             })
          }}
          value={{ amount: spaceRentalTax }}
          currencyType={currencyType}
        />
      )}
      {addOnsTax > 0 && (
        <LineItem
          label={{
            content: intl.formatMessage({
              id: 'overtime_summary.add-on-sales-tax',
              defaultMessage: 'Add-on sales tax'
            }),
            optionalClass: 'top-vertical-align'
          }}
          value={{ amount: addOnsTax }}
          currencyType={currencyType}
        />
      )}
      <BorderBottomLineItem />
      <LineItem
        label={{
          content: intl.formatMessage({ id: 'inbox_bookingID_overtime.tooltip_calculator.guest_pay', defaultMessage: 'Guest will pay' }),
          optionalClass: 'overtime-tooltip-total'
        }}
        value={{
          ...(overtimeGuestCharge ? { amount: overtimeGuestCharge } : { customValue: '-' }),
          optionalClass: 'remove-vertical-align overtime-tooltip-total'
        }}
        currencyType={currencyType}
        customClass="margin"
      />
    </RevisedCalculator>
  );
};

exports.OvertimeSummary = injectIntl(OvertimeSummary);
exports.TooltipCalculator = injectIntl(TooltipCalculator);
